import { useQuery } from '@tanstack/react-query';
import { admin } from './admin-api';

// RBAC (spec 12.4): the proprietary named methods behind each intervention. Superadmin-only —
// these strings appear in NO other payload or surface. Read-only.

export default function MethodRegistry() {
  const registry = useQuery({ queryKey: ['admin', 'method-registry'], queryFn: admin.methodRegistry });

  return (
    <div>
      <div className="ph">Admin · Method Registry</div>
      <div className="h2">Named methods (IP) · superadmin only</div>
      <p className="lead">The proprietary method behind each intervention. Never serialized to any other surface.</p>

      <div className="panel">
        <div className="qhead"><span className="qdot" style={{ background: 'var(--amber)' }} />{registry.data?.length ?? 0} interventions</div>
        {registry.isLoading ? (
          <div className="small faint">Loading…</div>
        ) : registry.isError ? (
          <div className="login-err">Method registry unavailable (superadmin required).</div>
        ) : (
          <table>
            <thead>
              <tr><th>Intervention</th><th>Named method</th><th>Modality</th><th>Learning</th></tr>
            </thead>
            <tbody>
              {registry.data?.map((m) => (
                <tr key={m.intervention_id}>
                  <td className="mono small">{m.intervention_id}</td>
                  <td className="small" style={{ color: 'var(--ink)' }}>{m.named_method}</td>
                  <td className="small"><span className="tag muted">{m.modality_class}</span></td>
                  <td className="small">{m.learning}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
